import { MapPreview as Layout } from 'ui-components'

import { useInitMapData } from '~map-preview/hooks/useInitMapData'
import { useGetMapById } from '~map-preview/queries/useGetMapById'
import { MapData } from '~map-preview/types/__generated/gql/graphql'

import { error } from '~map-preview/App/Error'
import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import { useIsMapSaved } from '~map-preview/states/map'
import { providers } from '~map-preview/states/provider'

import { MapGl } from './Map'

import { AccountProfile } from './Tools/AccountProfile'
import { MapBar } from './Tools/MapBar'
import { MapCreateButton } from './Tools/MapCreateButton'
import { MapCreateDrawer } from './Tools/MapCreateDrawer'
import { MapDataSettingsDrawer } from './Tools/MapDataSettingsDrawer'
import { MapDescriptionDrawer } from './Tools/MapDescriptionDrawer'
import { MapEmbedFullscreenButton } from './Tools/MapEmbedFullscreenButton'
import { MapFeatureInfoDrawer } from './Tools/MapFeatureInfoDrawer'
import { MapFilterDrawer } from './Tools/MapFilterDrawer'
import { MapLegend } from './Tools/MapLegend'
import { MapLegendDrawer } from './Tools/MapLegendDrawer'
import { MapName } from './Tools/MapName'
import { MapRemixDrawer } from './Tools/MapRemixDrawer'
import { MapSaveButton } from './Tools/MapSaveButton'
import { MapSaveDrawer } from './Tools/MapSaveDrawer'
import { MapSearch } from './Tools/MapSearch'
import { MapSettingsDrawer } from './Tools/MapSettingsDrawer'
import { MapShareDrawer } from './Tools/MapShareDrawer'
import { MapTable } from './Tools/MapTable'
import { NavDrawer } from './Tools/NavDrawer'
import { SpeedDial } from './Tools/SpeedDial'

interface AppProps {
  mapId: string
  map?: MapData
}

const App = providers(
  error((props: AppProps) => {
    const isEmbed = useIsEmbed()
    const saved = useIsMapSaved()
    const { mapId, map } = props

    useInitMapData(mapId, map)
    useGetMapById(mapId)

    return (
      <Layout
        isEmbed={isEmbed}
        slots={{
          AccountProfile,
          MapBar,
          MapCreateButton,
          MapCreateDrawer,
          MapDataSettingsDrawer: saved ? MapDataSettingsDrawer : () => null,
          MapDescriptionDrawer,
          MapEmbedFullscreenButton,
          MapFeatureInfoDrawer,
          MapFilterDrawer,
          MapGl,
          MapLegend,
          MapLegendDrawer,
          MapName,
          MapRemixDrawer,
          MapSaveButton,
          MapSaveDrawer,
          MapSearch,
          MapSettingsDrawer,
          MapShareDrawer,
          MapTable,
          NavDrawer,
          SpeedDial
        }}
      />
    )
  })
)

export { App }
